import { p as proxyCustomElement, H, h, a as Host } from './index.js';

const tagListCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;align-content:flex-start;background:#0000;box-sizing:border-box;display:flex;flex-wrap:wrap;font-family:Open Sans;font-size:.875rem;font-weight:400;height:auto;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;overflow-y:auto;padding:.25rem;transition:height .25s ease}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}::slotted(wui-tag){margin:0 .75rem .75rem 0}:host([size=md]){max-height:8rem}:host([size=lg]){max-height:15rem}:host([type=contained]){padding:0}:host([type=contained])>div{background-color:var(--jw-theme-form-field-default-bg-color);border:1px solid var(--jw-theme-form-border-regular-default-border-color);border-radius:.25rem;padding:.75rem;width:100%}";

const WuiTagList = /*@__PURE__*/ proxyCustomElement(class WuiTagList extends H {
    constructor(registerHost) {
        super();
        if (registerHost !== false) {
            this.__registerHost();
        }
        this.__attachShadow();
        /**
         * Size of the scroll container
         */
        this.size = 'md';
        /**
         * Variant of the tag list
         */
        this.type = 'default';
    }
    render() {
        return (h(Host, { key: '62b9fb7323288766ec5991365d28b536ba2f0eee' }, h("div", { key: '46292726ced7eedb246124abb1edeb44cc7b3e08' }, h("slot", { key: '9cb209bda5dc929a95d0d3a42451f1f1d21b0624' }))));
    }
    static get style() { return tagListCss; }
}, [257, "wui-tag-list", {
        "size": [513],
        "type": [513]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-tag-list"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-tag-list":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiTagList);
            }
            break;
    } });
}
defineCustomElement();

export { WuiTagList as W, defineCustomElement as d };
